import { createContext } from "react";

export const StateLoading = createContext(false);
export const AccordionContext = createContext(false);
